module.exports = __webpack_public_path__ + "img/url.8b6c7cc.svg";